<template>
    <div class="flex flex-col justify-center h-full">
        <div v-for="(feature, index) in features" :key="feature" class="flex items-center" :class="{ 'mb-3': index !== features.length - 1}">
            <i class="sr-2 sr-v2-checkmark-circle ds-text-3xl text-green-300 mr-3" />
            <span class="ds-text-base text-white">{{feature}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            features: { type: Array, required: true },
        }
    }
</script>